<template>
    <div class="footer bg-white py-4 pl-5 pr-5 user-select-none" :class="[margin ? 'mt-5' : 'mt-0']" id="kt_footer">
        <div class="pl-5 pr-5 d-flex flex-column flex-sm-row align-items-center justify-content-between">
            <div class="text-dark order-2 order-md-1 d-flex flex-row align-items-center justify-content-between text-nowrap">
                <span class="text-muted font-weight-bold mr-2">{{ new Date().getFullYear() }} &copy;</span>
                <a :href="$frontendUrl()" target="_blank" class="text-dark-75 font-weight-bold">youbuyda GmbH</a>
                <LanguageSelect class="ml-5"/>
            </div>
            <div class="nav nav-dark">
                <a v-for="link in footerLinks" :href="link.url" target="_blank" class="nav-link pr-0">
                    {{ link.title }}
                </a>
            </div>
        </div>
    </div>
</template>

<script>

import LanguageSelect from '../../components/LanguageSelect.vue';

export default {
    components: {
        LanguageSelect,
    },
    props: {
        margin: {
            type: Boolean,
            default: true
        }
    },
    data() {
        return {
            footerLinks: [
                {
                    url: this.$frontendUrl() + '/faq',
                    title: __('navigation.faq'),
                },
                {
                    url: this.$route('contact'),
                    title: __('navigation.contact'),
                },
                {
                    url: this.$frontendUrl() + '/agb',
                    title: __('navigation.homepage.conditions_abbr'),
                },
                {
                    url: this.$frontendUrl() + '/datenschutz',
                    title: __('navigation.homepage.privacy'),
                },
            ],
        };
    },
};
</script>
